import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PriceCard } from './PriceCard';
import { price, systemSummary, whatYouGet } from '../data/salesPage';
export function PricingSection() {
  return <section aria-labelledby="precio-titulo" id="precio" className="bg-ink" data-id="element-184" data-mp="1ehp3u4wbcpeh">
      <div className="mx-auto max-w-6xl px-5 py-20 sm:py-28" data-id="element-185" data-mp="1j8ysp3a1fopb">
        <h2 className="text-center font-display text-sm font-bold uppercase tracking-[0.25em] text-lime" data-id="element-186" data-mp="1ja9vazrqyqeu">Todo esto en un solo sistema</h2>
        <ul className="mt-6 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-ink-line bg-ink-line lg:grid-cols-4" data-id="element-187" data-mp="1s9n9g5qtg35w">
          {systemSummary.map(item => <li key={item} className="bg-ink-raised px-4 py-6 text-center font-display text-lg font-black uppercase leading-tight text-bone sm:text-xl" data-id="element-188" data-mp="1x6nau3cq0hqo">
              {item}
            </li>)}
        </ul>

        <div className="mt-24 text-center" data-id="element-189" data-mp="7tsa5vtloa7i">
          <h3 id="precio-titulo" className="font-display text-4xl font-black uppercase text-bone sm:text-6xl" data-id="element-190" data-mp="7utoc95wxctg">
            ¿Cuánto vale todo esto?
          </h3>
          <p className="mx-auto mt-5 max-w-xl text-lg text-bone-muted" data-id="element-191" data-mp="1hq81xt1rtrz1">
            Si tuvieras que comprar por separado todo el contenido, herramientas y materiales incluidos: <span className="text-bone" data-id="element-192" data-mp="1cr4y2bxj1rsn">{price.reference}</span>. Pero hoy no vas a pagar eso.
          </p>
        </div>

        <div className="mt-12 grid items-center gap-14 lg:grid-cols-[1.1fr_1fr]" data-id="element-193" data-mp="25fitcjx8ea0i">
          <PriceCard eyebrow="Precio especial de lanzamiento" showSavings data-id="element-194" data-mp="25dg4423wkkwu" />

          <div data-id="element-195" data-mp="20gz7ejin0y85">
            <p className="font-display text-2xl font-black uppercase leading-tight text-bone" data-id="element-196" data-mp="20eczujvqyipx">
              No estás comprando solamente un PDF.
            </p>
            <p className="mt-2 text-lg text-bone-muted" data-id="element-197" data-mp="1repy1wz3vawc">Estás adquiriendo:</p>
            <ul className="mt-6 space-y-3.5" data-id="element-198" data-mp="k2phvm2nt3fq">
              {whatYouGet.map(item => <li key={item} className="flex items-start gap-3 text-lg text-bone" data-id="element-199" data-mp="g0ufsfcwmm0w">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-lime" data-id="element-200" data-mp="hhrt8ylzkzno">
                    <CheckIcon className="h-3.5 w-3.5 text-ink" strokeWidth={3} aria-hidden="true" data-id="element-201" data-mp="mgkw7x3nd89l" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}